export enum LookupDataProvidersQueryKey {
    Standards = "standards",
    AspectTypes = "aspect-types",
    AspectRatios = "aspect-ratios"
}
